module.exports = __webpack_public_path__ + "assets/img/vestamosnoaiq_desconto_black-feed.9797615a.png";